import { render } from "./HomeEnglish.vue?vue&type=template&id=bd5fd25a&scoped=true"
import script from "./HomeEnglish.vue?vue&type=script&lang=js"
export * from "./HomeEnglish.vue?vue&type=script&lang=js"

import "./HomeEnglish.vue?vue&type=style&index=0&id=bd5fd25a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5fd25a"]])

export default __exports__